/* eslint-disable no-template-curly-in-string */
import { object, string } from 'yup';
import { translateAndCastToString } from '../../../../utils';

export const supplierValidationSchema = object().shape({
    legalName:  string()
        .min(2, translateAndCastToString('Too Short!'))
        .max(50, translateAndCastToString('Too Long!'))
        .required('Required'),
    district: string()
        .min(2, translateAndCastToString('Too Short!'))
        .max(50, translateAndCastToString('Too Long!'))
        .optional(),
    headquarters: string()
        .min(2, translateAndCastToString('Too Short!'))
        .max(50, translateAndCastToString('Too Long!'))
        .optional(),
    postalCode: string()
        .min(3, translateAndCastToString('Too Short!'))
        .max(6, translateAndCastToString('Too Long!'))
        .optional(),
    tin: string()
        .min(5, translateAndCastToString('Too Short!'))
        .max(20, translateAndCastToString('Too Long!'))
        .optional(),
    companyIdentificationNumber: string()
        .min(5, translateAndCastToString('Too Short!'))
        .max(20, translateAndCastToString('Too Long!'))
        .optional(),
});
